var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:['kpi-status-badge', _setup.statusKey]},[_vm._v(" "+_vm._s(_setup.displayLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }